import { render, staticRenderFns } from "./vLiveVideo.vue?vue&type=template&id=7a08533f&scoped=true"
import script from "./vLiveVideo.vue?vue&type=script&lang=js"
export * from "./vLiveVideo.vue?vue&type=script&lang=js"
import style0 from "./vLiveVideo.vue?vue&type=style&index=0&id=7a08533f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08533f",
  null
  
)

export default component.exports